/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'sites/allas/components/standalone/ArticleFooter/theme';

export const ArticleFooterTheme = theme;
